"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization;
var LazyNavLinkImage = function LazyNavLinkImage(_ref) {
  var checkedLink = _ref.checkedLink;
  var imageWidth = 480;
  var imageSrc = handleNestedProp(checkedLink, 'checkedLink.vehicleImage.image');
  var isBackground = false;
  var isWebp = true;
  var imageQuality = 70;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].navLinkImage
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: "" + appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
    srcSet: [appendImageOptimization(imageSrc, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w"].join(','),
    sizes: "(max-width: 768px) 20vw, 30vw",
    alt: handleNestedProp(checkedLink, 'checkedLink.vehicleImage.altText')
  }));
};
var _default = exports["default"] = LazyNavLinkImage;